import { defineComponent as _defineComponent } from 'vue'
import ButtonCheckBox from '@/components/inputs/ButtonCheckBox.vue';
import { dateTimeFormats } from '@/lang/dateTimeFormats';
import { ScheduleViewMode } from '@/lib/enum/schedule-v2/ScheduleViewMode';
import { getDateHeaders } from '@/lib/schedule-v2/scheduleV2Functions';
import store from '@/store';
import { ColumnHeader } from '@/types/schedule';
import { computed, ref, watch } from 'vue';
import SwitchInput from '../inputs/SwitchInput.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'RepeatShifts',
  props: {
    date: null,
    value: null,
    showRepeatDays: { type: Boolean }
  },
  emits: ["input", "showDaysToRepeat"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'input', value: number[]): void;
  (e: 'showDaysToRepeat', value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  date: Date;
  value: number[];
  showRepeatDays: boolean;
}




const showDaysToRepeat = ref<boolean>(props.showRepeatDays);
const daysToRepeatShifts = ref<number[]>(props.value);

const timezone = computed(() => store.getters.timezone);

const daysOfTheWeek = computed<ColumnHeader[]>(() =>
  getDateHeaders(
    props.date,
    timezone.value,
    ScheduleViewMode.Week,
    dateTimeFormats.weekdayShort,
    dateTimeFormats.dayMonth,
  ),
);

watch(
  () => daysToRepeatShifts.value,
  (newVal) => {
    emit('input', newVal);
  },
);

return { __sfc: true,props, emit, showDaysToRepeat, daysToRepeatShifts, timezone, daysOfTheWeek, ButtonCheckBox, SwitchInput }
}

})